import { render, staticRenderFns } from "./VqRadio.vue?vue&type=template&id=0f3c2e95&scoped=true&lang=html&"
import script from "./VqRadio.vue?vue&type=script&lang=js&"
export * from "./VqRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c2e95",
  null
  
)

export default component.exports